import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createAuthAccountBalanceReduceObject } from '../../../common/reducers/state/authAccountBalance';
import authAccountBalanceSaga from './sagas/authAccountBalanceSaga';

export default [
  ...createCombineMapItem(
    'authAccountBalance',
    createAuthAccountBalanceReduceObject,
    [authAccountBalanceSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/states/reducersMap.js